<template>
  <div style="width: 376px; height: 210px">
    <MyEcharts v-if="showcdata" :id="'guangfuchart11'" :options="cdata" />
  </div>
</template>

<script>
import divBox2 from "@/views/mobile/components/divbox2";
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import * as echarts from "echarts5";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    divBox2,
    MyEcharts,
  },
  data() {
    return {
      showcdata: false,
      // title:"车辆新增及活跃趋势",
      cdata: {
        title: {
            text: '%'
          },
        backgroundColor: "rgba(0, 0, 0, 0.1)",
        tooltip: {
          trigger: "axis",
          show: true,
          grid: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          },
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: "value",
          splitLine: false,
        },
        series: [
          {
            name: "发电效率",
            type: "line",
            color: '#16F5F9',
			tooltip: {
				valueFormatter: function (value) {
					return value + ' %';
				}
			},
            smooth: true,
            data: [],
            lineStyle: {
              width: 2,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {
                  offset: 0,
                  color: "#16F5F9",
                },
                {
                  offset: 1,
                  color: "#16F5F9",
                },
              ]),
            },
          },
        ],
      },
    };
  },
  destroyed() {
    // this.$bus.$off('offCloseFunction')
  },
  mounted() {
    // this.$bus.$on("offCloseFunction", () => {
    //   this.getBattery24hours();
    // });
    this.getBattery24hours();
  },
  methods: {
    //获取24小时电次数分布
    getBattery24hours() {
      this.showcdata = false;
      let params = {
        enCode: "snec-mid-gf-power-efficiency",
        "@harbour_id":
          localStorage.getItem("harbour_id") ||
          "76df7579ccc24d2693f6488c38a3a0b0",
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (res) {
            console.log(res, "光伏发电趋势图");
            let data = [];
            let xAxis = [];
            res.forEach((item) => {
              xAxis.push(item.ts);
              data.push(item.percent);
            });
            this.cdata.xAxis.data = xAxis;
            this.cdata.series[0].data = data;
            this.showcdata = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

